import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { RHFTextField } from "../../../components/Forms";
import { P } from "../../../components/Typography";
import { FocusedList } from "../FocusedList";
import { FormStepCard } from "./FormStepCard";
import { SessionTodos } from "./SessionTodos";
import { useReflectionHints } from "./hints";
import { SESSION_FIELDS } from "./constants";
import { useMsg } from "../../../components/Msg/Msg";
import { sessionsMessages } from "../messages";
import { Icon } from "../../../components/Icon";

const emptyArr = [];

export const ReflectStep = ({
  step,
  stepper,
  data,
  motivation = "",
  lastReflection = "",
  previousActionSteps: previousActionStepsProp = [],
  submitDisabled,
}) => {
  const previousActionSteps = previousActionStepsProp.filter(
    ({ checked }) => !checked, // display just not completed
  );
  const msg = useMsg({ dict: sessionsMessages });
  const hints = useReflectionHints();
  const reflectionField = step.fieldDefMap[SESSION_FIELDS.REFLECTION];

  // console.log("[ReflectStep.rndr]", {
  //   previousActionStepsProp,
  //   previousActionSteps,
  //   data,
  // });

  return (
    <FormStepCard
      {...{
        step,
        stepper,
        data: {
          ...data,
          [SESSION_FIELDS.PREV_ACTION_STEPS]:
            data[SESSION_FIELDS.PREV_ACTION_STEPS] ||
            previousActionSteps ||
            emptyArr,
        },
        submitDisabled,
      }}
    >
      <SessionTodos name={SESSION_FIELDS.PREV_ACTION_STEPS} />
      <Accordion
        sx={{
          my: 3,
          bgcolor: "#FCFCFD",
          boxShadow: "none",
          borderRadius: "6px",
          "&:before": {
            display: "none",
          },
        }}
      >
        <AccordionSummary
          sx={{ fontSize: 16 }}
          expandIcon={<Icon name="ExpandMore" />}
        >
          {msg("sessions.edit.steps.reflect.reflection-heading")}
        </AccordionSummary>
        <AccordionDetails>
          <P sx={{ whiteSpace: "pre-wrap", lineHeight: 1.8 }}>
            {lastReflection || motivation}
          </P>
        </AccordionDetails>
      </Accordion>
      <AccordionSummary sx={{ fontSize: 16 }}>
        {msg("sessions.edit.steps.reflect.reflection-questions-heading")}
      </AccordionSummary>
      <FocusedList items={hints} />
      <RHFTextField
        name={SESSION_FIELDS.REFLECTION}
        rules={{
          required: "Required",
          validate: { ...(reflectionField.validate ?? {}) },
        }}
        placeholder={msg("sessions.edit.steps.reflect.reflection.placeholder")}
        autoFocus
        size="small"
        hiddenLabel
        multiline
        rows={4}
        sx={{ my: 4 }}
        fullWidth
      />
    </FormStepCard>
  );
};
